import { defineStore } from 'pinia';
export default defineStore('layout', {
  state: () => ({
    //
    // 头部导航栏Ref
    headerRef: null,
    // 侧边栏Ref
    siderRef: null,
    // 是否显示头部
    showHeader: true,
    // 是否显示侧边栏
    showSider: true,
    // 是否为放大模式
    isExpand: false,
  }),

  actions: {
    // 操作主体区域变大
    async expandMain() {
      this.showHeader = false;
      this.showSider = false;
      this.isExpand = true;
    },
    // 操作区域变小
    async shrinkMain() {
      this.showHeader = true;
      this.showSider = true;
      this.isExpand = false;
    },
    //  切换放大缩小
    async toggleExpand() {
      if (this.isExpand) {
        this.shrinkMain();
      } else {
        this.expandMain();
      }
    },
  },
});
